import Empty from '@/views/Empty';
import IssueList from '@/views/pages/issues/List';
import IssueDetail from '@/views/pages/issues/detail/Detail';
import DetailIndex from '@/views/pages/issues/DetailIndex';

export default {
  path: 'issues',
  component: Empty,
  meta: {
    accessKey: 'MAIN.ISSUE.READ',
  },
  children: [
    {
      path: '',
      name: 'Issues',
      component: IssueList,
    },
    {
      path: ':issueId',
      component: DetailIndex,
      children: [
        {
          path: '',
          name: 'Issue Detail',
          component: IssueDetail,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/issues.js